export const JOURNEY_GET_QUOTE = 'GET_QUOTE';
export const JOURNEY_YOUR_QUOTE = 'YOUR_QUOTE';
export const JOURNEY_YOUR_PRODUCT = 'YOUR_PRODUCT';
export const JOURNEY_PAYMENT = 'PAYMENT';